<!-- 承运商档案>新增>基础信息 -->
<template>
  <div id="baseInfo">
    <div class="formbox">
      <el-form
        :model="baseInForm"
        ref="baseInForm"
        label-width="110px"
        class="glo_formBox"
      >
        <el-form-item label="对接系统:" prop="thirdApiPlatformConfDictId">
          <el-select
            v-model="baseInForm.thirdApiPlatformConfDictId"
            placeholder="请选择"
          >
            <el-option
              v-for="(itemA, idxA) in thirdApiPlatformList"
              :key="idxA"
              :label="itemA.descript"
              :value="itemA.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="渠道ID:" prop="appId">
          <el-input v-model="baseInForm.appId" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="秘钥key:" prop="appSecret">
          <el-input
            v-model="baseInForm.appSecret"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="btmBtns">
      <el-button class="glo_bgcMainColor saveBtns" @click="submit"
        >保 存</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    common: {
      type: Object,
    },
  },
  emits: ["RELOADPAGE"],
  data() {
    return {
      thirdApiPlatformList: [],
      baseInForm: {
        appId: "",
        appSecret: "",
        thirdApiPlatformConfDictId: null,
      },
      carrierId: this.common.carrierId,
    };
  },
  watch: {
    common: {
      handler(nv, ov) {
        this.carrierId = nv.carrierId;
        this.baseInForm = {
          appId: "",
          appSecret: "",
          thirdApiPlatformConfDictId: null,
        };
        if (this.carrierId) {
          this.getThirdApiPlatform();
          this.getSystem();
        }
        console.log("nv", nv);
        console.log(" this.carrierId", this.carrierId);
      },
      deep: true,
    },
  },
  activated() {},
  created() {},
  mounted() {
    console.log("AAA this.carrierId", this.carrierId);
    if (this.carrierId) {
      this.getThirdApiPlatform();
      this.getSystem();
    }
  },
  methods: {
    getThirdApiPlatform() {
      this.$API
        .getThirdApiPlatform({ carrierId: this.carrierId })
        .then((res) => {
          this.thirdApiPlatformList = res.data.result || [];
          if (this.thirdApiPlatformList.length > 0) {
            this.baseInForm.appSecret = this.thirdApiPlatformList[0].appSecret;
            this.baseInForm.appId = this.thirdApiPlatformList[0].appId;
            this.baseInForm.thirdApiPlatformConfDictId =
              this.thirdApiPlatformList[0].thirdApiPlatformConfDictId * 1;
          }
        });
    },

    getSystem() {
      this.$API
        .runPageReportDetails({
          number: "select_dict_by_type",
          conditionReqs: [
            {
              conditonKey: "type",
              conditonVal: "third_api_platform",
            },
          ],
        })
        .then((res) => {
          this.thirdApiPlatformList = res.data.result.datas || [];
          if (this.thirdApiPlatformList.length > 0) {
            this.baseInForm.thirdApiPlatformConfDictId =
              this.thirdApiPlatformList[0].id * 1;
          }
        });
    },

    submit() {
      let param = {
        carrierId: this.carrierId,
        platformInfos: [
          {
            appId: this.baseInForm.appId,
            appSecret: this.baseInForm.appSecret,
            thirdApiPlatformConfDictId: this.baseInForm
              .thirdApiPlatformConfDictId,
          },
        ],
      };
      this.$API.savaThirdApiPlatform(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
      });
    },
    RELOADPAGE() {
      this.$emit("RELOADPAGE");
    },
  },
};
</script>
<style scoped lang="less">
#baseInfo {
  margin: 60px 40px;
  .disFlexs {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .selectAddress {
    border: 1px solid #ccc;
    margin-right: 10px;
    width: 180px !important;
  }
  .addressDetails {
    //   width: 380px !important;
    flex: 1;
  }
  .btmBtns {
    text-align: center;
    margin-top: 50px;

    .saveBtns {
      font-size: 16px;
    }
  }
}
.disFlex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
